﻿import { Directive } from "@app/components/directive";
import { NgComponent } from "@app/di/decorators";
import { Token } from "@app/di/token";

@NgComponent({
    token: Token.KbSpinnerElement,
    dependencies: [
    ]
})
export class KbSpinnerElement extends Directive {
    constructor() {
        super();

        this.restrict = "E";
        this.scope = {
            tracker: "=?",
            show: "=?",
            label: "=?"
        };
        this.replace = true;

        this.template = "<div ng-show='tracker.active() && show' class='kb-cube kb-fade'>" +
            "<div class='kb-cube__cloak'></div>" +
            "<div class='kb-cube__cube'>" +
            "<div class='kb-cube__face kb-cube__one'></div>" +
            "<div class='kb-cube__face kb-cube__two'></div>" +
            "<div class='kb-cube__face kb-cube__three'></div>" +
            "<div class='kb-cube__face kb-cube__four'></div>" +
            "<div class='kb-cube__face kb-cube__five'></div>" +
            "<div class='kb-cube__face kb-cube__six'></div>" +
            "</div>" +
            "<div class='kb-cube__label'>{{label}}</div>" +
            "</div>";

        this.link = (scope: any, element, atts: any) => {
            // get the template

        };
    }
}
